import { useState } from 'react';
import { getValuableVariables } from '@anytag/shared-utils';
import { ParamsSearchReturnType } from '@anytag/shared-hooks';
import { FacebookAccountInfluencerSearchResultV2, useAllFacebookAccountInfluencersV2Query } from '@anytag/graphql';
import { formatInfluencerProfile } from '../utils';
import { FacebookInfluencersSearchSchemaType, FacebookInfluencersProps } from '../schemaTypes';
import { useGetInfluencersQueryVariables } from '../../hooks';

type Props = Pick<ParamsSearchReturnType<FacebookInfluencersSearchSchemaType>, 'page' | 'limit' | 'filter' | 'sort'> &
  Pick<FacebookInfluencersProps, 'getCurrentProfiles'>;

export const useFacebookInfluencersList = ({ page, sort, limit, filter, getCurrentProfiles }: Props) => {
  // Using data directly from query can be empty if skipSearch is true
  // But we still want to keep old data in that case, so we store it in state
  const [data, setData] = useState<FacebookAccountInfluencerSearchResultV2>();
  const { skipSearch, variables } = useGetInfluencersQueryVariables({ page, limit, filter });
  const { loading } = useAllFacebookAccountInfluencersV2Query({
    skip: skipSearch || !filter,
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
    variables: getValuableVariables({ ...variables, orderBy: sort }),
    onCompleted: ({ allFacebookAccountInfluencersV2 }) => {
      setData(allFacebookAccountInfluencersV2);
      getCurrentProfiles?.(allFacebookAccountInfluencersV2.facebookAccounts.map(formatInfluencerProfile));
    }
  });

  return {
    loading,
    totalRecords: data?.totalNumber || 0,
    listRecords: data?.facebookAccounts.map(formatInfluencerProfile) || []
  };
};
